import { RECEIPT_FILE_READ_ERROR } from './constants';

export const fileToRawBase64 = (file: File): Promise<string> => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        const rejectRead = (): void => {
            reject(new Error(RECEIPT_FILE_READ_ERROR));
        };

        reader.onload = () => {
            const { result } = reader;

            if (typeof result !== 'string') {
                rejectRead();

                return;
            }

            const commaIndex = result.indexOf(',');
            const metadata = result.slice(0, commaIndex);

            if (commaIndex === -1 || !metadata.startsWith('data:') || !metadata.endsWith(';base64')) {
                rejectRead();

                return;
            }

            resolve(result.slice(commaIndex + 1));
        };
        reader.onerror = rejectRead;
        reader.onabort = rejectRead;
        reader.readAsDataURL(file);
    });
};
